import dayjs from "dayjs";

/**
 * Date of birth is a calendar date, not an instant, so it is stored as a bare
 * "YYYY-MM-DD" string. Storing a full ISO timestamp re-introduces the
 * off-by-one-day bug for anyone east of UTC (local midnight serializes to the
 * previous day in Zulu).
 */
export const DOB_VALUE_FORMAT = "YYYY-MM-DD";

const ISO_DATE_PREFIX = /^\d{4}-\d{2}-\d{2}/;

/**
 * Parse a stored DOB into a dayjs day. Accepts the "YYYY-MM-DD" this field
 * writes, plus the full ISO timestamps older records/backends may hold — those
 * are truncated to their date portion rather than converted, so the calendar
 * date the user typed is the calendar date that comes back.
 */
export const parseDateOfBirth = (value) => {
  if (!value) return null;
  if (typeof value === "string") {
    const match = value.match(ISO_DATE_PREFIX);
    const d = dayjs(match ? match[0] : value);
    return d.isValid() ? d.startOf("day") : null;
  }
  const d = dayjs(value);
  return d.isValid() ? d.startOf("day") : null;
};

/** True when the birth date falls on today's month and day. */
export const isBirthdayToday = (value, asOf) => {
  const birth = parseDateOfBirth(value);
  if (!birth) return false;
  const reference = (asOf ? dayjs(asOf) : dayjs()).startOf("day");
  return birth.month() === reference.month() && birth.date() === reference.date();
};

/** Whole years as of today (or `asOf`). Returns null for an unparseable value. */
export const calculateAge = (value, asOf) => {
  const birth = parseDateOfBirth(value);
  if (!birth) return null;
  const reference = (asOf ? dayjs(asOf) : dayjs()).startOf("day");
  return reference.diff(birth, "year");
};

export default parseDateOfBirth;
